export const GTM_CONST_API_VERSION_V1 = 'v1'
export const GTM_CONST_APPLICATION_NAME = 'fock'
export const GTM_EVENT_CLICK_PRODUCT = 'click on product list item'
export const GTM_EVENT_CLICK_PRODUCT_OFFERS = 'viewOffers_search'
